import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TablePagination,
    TableRow,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import { translate } from 'react-i18next';
import SpecialDestinationTableHeader from './SpecialDestinationTableHeader';
import SpecialDestinationTableMenu from './SpecialDestinationTableMenu';
import SpecialDestinationTableToolbar from './SpecialDestinationTableToolbar';

import SpecialDestinationAddDialog from '../Dialogs/SpecialDestinationAddDialog';
import SpecialDestinationDeleteDialog from '../Dialogs/SpecialDestinationDeleteDialog';


const allowedActions = ['EDIT', 'DELETE'];

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 800,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    invoiceLocator: {
        color: 'var(--primary-color)'
    }
});

class SpecialDestinationTable extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            order: 'asc',
            orderBy: 'id',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 10,
            anchorEl: null,
            specialDestination: {},
            specialDestinationToDelete: {},
            openAdd: false,
            openDelete: false
        };
    }

    /**
     * Sort Table data.
     * @param {type} event
     * @param {String} property column id
     */
    handleRequestSort = (event, property) => {
        if (property === 'actions' || property === 'state') {
            return;
        }

        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            this.props.data ?
                order === 'desc' ?
                    this.props.data.sort((a, b) => {
                        if (b.hasOwnProperty(orderBy) && a.hasOwnProperty(orderBy)) {
                            return (String(b[orderBy]).toUpperCase() < String(a[orderBy]).toUpperCase() ? -1 : 1);
                        } else {
                            return 1;
                        }
                    })
                    : this.props.data.sort((a, b) => {
                        if (b.hasOwnProperty(orderBy) && a.hasOwnProperty(orderBy)) {
                            return (String(a[orderBy]).toUpperCase() < String(b[orderBy]).toUpperCase() ? -1 : 1);
                        } else {
                            return 1;
                        }
                    })
                : [];

        this.setState({ data, order, orderBy });
    };

    tableActionsMenuHandler = (specialDestination, action) => {
        switch (action) {
        case 'ADD':
            this.setState({ specialDestination: null });
            this.openAddSpecialDestination();
            break;
        case 'DELETE':
            this.setState({ specialDestinationToDelete: specialDestination });
            this.openDeleteSpecialDestination();
            break;
        case 'EDIT':
            this.setState({ specialDestination: specialDestination });
            this.openAddSpecialDestination();
            break;
        default:
            break;
        }
    };

    openAddSpecialDestination = () => {
        this.setState({ openAdd: true });
    };

    closeAddSpecialDestination = success => {
        if (success) {
            this.props.fetchBackendData();
        }
        this.setState({ openAdd: false });
    };


    openDeleteSpecialDestination = () => {
        this.setState({ openDelete: true });
    };

    closeDeleteSpecialDestination = success => {
        if (success) {
            this.props.fetchBackendData();
        }
        this.setState({ openDelete: false, SpecialDestinationToDelete: {} });
    };



    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    render() {
        const { classes, t, type } = this.props;

        const { order, orderBy, selected, rowsPerPage, page } = this.state;

        let length = this.props.data.length || 0;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, length - page * rowsPerPage);

        return (
            <div>
                <Paper className={classes.root}>
                    <SpecialDestinationTableToolbar
                        fetchBackendData={this.props.fetchBackendData}
                        actionHandler={this.tableActionsMenuHandler}
                        type={type}
                    />
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            <SpecialDestinationTableHeader
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={this.props.data.length}
                                t={t}
                            />
                            <TableBody>
                                {this.props.data && this.props.data.length ?
                                    this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                        const isSelected = this.isSelected(n.id);
                                        return (
                                            <TableRow
                                                hover
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.id}
                                                selected={isSelected}>
                                                <TableCell
                                                    padding={'none'}
                                                    style={{ paddingLeft: '10px' }}>
                                                    <a
                                                        className={classes.invoiceLocator}
                                                        href={type && type === 'Nautalia'? '#/especialdestinationsnautalia' : '#/especialdestinations'}
                                                        onClick={(event) => {
                                                            this.tableActionsMenuHandler(n, 'EDIT');
                                                        }}
                                                    ><b>{n.name}</b></a>
                                                </TableCell>
                                                <TableCell padding={'none'}>
                                                    <SpecialDestinationTableMenu
                                                        specialDestination={n}
                                                        options={allowedActions}
                                                        actionHandler={this.tableActionsMenuHandler}
                                                        labels={{
                                                            EDIT: t('SPECIAL_DESTINATION.EDIT'),
                                                            DELETE: t('SPECIAL_DESTINATION.DELETE')
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                    :
                                    emptyRows > 0 && (
                                        <TableRow style={{ height: 49 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={this.props.data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        labelRowsPerPage={'Mostrando'}
                                        labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count}`}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>
                </Paper>

                <SpecialDestinationAddDialog
                    open={this.state.openAdd}
                    onClose={this.closeAddSpecialDestination}
                    specialDestination={this.state.specialDestination}
                    type={this.props.type}
                />

                <SpecialDestinationDeleteDialog
                    open={this.state.openDelete}
                    onClose={this.closeDeleteSpecialDestination}
                    specialDestination={this.state.specialDestinationToDelete}
                />

            </div>
        );
    }
}

SpecialDestinationTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default translate('translations')(withStyles(styles)(SpecialDestinationTable));


// WEBPACK FOOTER //
// ./src/components/SpecialDestinations/Table/SpecialDestinationTable.js